import { cpf as CPF } from 'cpf-cnpj-validator';
import * as yup from 'yup';

export const SellerCodeSchema =  yup.object().shape({
  code: yup
    .string()
    .required(' ')
    .matches(/^\d{3}\.?\d{3}\.?\d{3}-?\d{2}/, 'CPF inválido')
    .test('custom-cpf-validation', ' ', (cpf) => {
      const cpfNumber = cpf?.replace(/[.-]/g, '');
      return CPF.isValid(cpfNumber);
    })
    .typeError('O campo CPF é obrigatório'),
});
